import React, { useEffect } from 'react';
import Script from 'next/script';
import styled from 'styled-components';
import BlockWrapper from './BlockWrapper';
import Container from '../interface/Container';

const Title = styled.h2`
  font-family: var(--font-tertiary);
  font-weight: var(--font-weight-regular);
  font-size: 3.8rem;
  margin-bottom: 4rem;
`;

const WidgetWrapper = styled.div`
  min-height: 500px;
`;

const BsportAppointmentsWidget = ({ block }) => {
  // Parse widget configuration from JSON
  const getWidgetConfig = () => {
    // Default configuration
    const defaultConfig = {
      parentElement: 'bsport-widget-517073',
      companyId: 2917,
      franchiseId: null,
      dialogMode: 1,
      widgetType: 'privateService',
      showFab: false,
      fullScreenPopup: false,
      styles: undefined,
      config: {
        privateService: {
          type: 'list',
        },
      },
    };

    // If widgetConfig is provided, parse and merge with defaults
    if (block.widgetConfig) {
      try {
        // Sanitize the JSON string by replacing undefined with null
        const sanitizedConfig = block.widgetConfig.replace(/:\s*undefined(\s*[,}])/g, ': null$1');
        const customConfig = JSON.parse(sanitizedConfig);
        return { ...defaultConfig, ...customConfig };
      } catch (error) {
        console.error('Invalid widget config JSON:', error);
        return defaultConfig;
      }
    }

    return defaultConfig;
  };

  const widgetConfig = getWidgetConfig();

  useEffect(() => {
    const mountWidget = (config, repeat = 1) => {
      if (repeat > 50) return;

      if (!window.BsportWidget) {
        return setTimeout(() => {
          mountWidget(config, repeat + 1);
        }, 100 * repeat || 1);
      }

      window.BsportWidget.mount(config);
    };

    mountWidget(widgetConfig);
  }, [widgetConfig]);

  return (
    <BlockWrapper>
      <Container>
        {block.mainTitle && <Title>{block.mainTitle}</Title>}
        <Script id="bsport-widget-cdn" src="https://cdn.bsport.io/scripts/widget.js" strategy="afterInteractive" />
        <WidgetWrapper id={widgetConfig.parentElement} />
      </Container>
    </BlockWrapper>
  );
};

export default BsportAppointmentsWidget;
